import type { StorySetup } from '../types';
import type { PlayerPreferences } from './types';

/** CSS filters behind the colour treatments (player stage and look previews). */
export const COLOR_FILTERS = {
  natural: undefined,
  warm: 'saturate(1.06) sepia(0.08) contrast(1.02)',
  film: 'contrast(1.06) saturate(0.86) sepia(0.12) brightness(0.98)',
} as const;

/**
 * The music and finished look the user chose for one episode, as player
 * settings that apply on top of their saved preferences while it plays.
 * Changing one of these in the player hands that setting back to the
 * saved preferences (see FilmPlayer).
 */
export function episodeOverrides(setup: StorySetup | undefined): Partial<PlayerPreferences> {
  const out: Partial<PlayerPreferences> = {};
  if (setup?.look) {
    const { pace, transition, colorTreatment, vignette, photoAnimation } = setup.look;
    Object.assign(out, { pace, transition, colorTreatment, vignette, photoAnimation });
  }
  if (setup?.music) {
    if (!setup.music.enabled) out.musicEnabled = false;
    else if (setup.music.trackIds.length > 0) Object.assign(out, { musicEnabled: true, playlist: setup.music.trackIds });
  }
  return out;
}
